export default {
    user: state => state.user,
    uid: state => state.uid,
    token: state => state.token,
    online: state => state.online,
    devInfo: state => state.devInfo,
    OFFSET: state => state.OFFSET,
    inviteCode: state => state.inviteCode,
    newMessage: state => state.newMessage,
    messages: state => state.messages,
    neteasecloud: state => state.neteasecloud,
		drawGameId:state => state.drawGameId,
    drawInviteCode:state => state.drawInviteCode,
    isCanDrawFlag: state => state.isCanDrawFlag

}